import { AppThunkAction } from '.';
import { Action, Reducer } from 'redux'
import * as myCfg from '../AppConfig';
import { APIContainer, LogTypes, ResetStore, sawinFunc } from './sawinLib';
import * as CustomerFeedbackMdl from '../models/CustomerFeedbackModel';
// -----------------
// STATE - This defines the type of data maintained in the Redux store.


export interface CustomerFeedbackProcessing { type: 'CUSTOMERFEEDBACK_PROCESSING', processing: boolean }
export interface CustomerFeedbackError { type: 'CUSTOMERFEEDBACK_ERROR', error: string }
export interface CustomerFeedbackSuccess { type: 'CUSTOMERFEEDBACK_SUCCESS' }
export interface CustomerFeedbackReset { type: 'CUSTOMERFEEDBACK_RESET' }

export type KnownAction = CustomerFeedbackProcessing | CustomerFeedbackError | CustomerFeedbackSuccess | CustomerFeedbackReset;

export const actionCreators = {
    request: (pCustomerFeedback: CustomerFeedbackMdl.CustomerFeedbackModel): AppThunkAction<KnownAction> => (dispatch, getState) => {
        const appState = getState();
        const sessionState = appState.sessionState;
        
        pCustomerFeedback.serviceMaster = sessionState.SelectedSM.id;
        pCustomerFeedback.companyCode = sessionState.SelectedAR.companyCode;

        dispatch({ type: 'CUSTOMERFEEDBACK_PROCESSING', processing: true });
        sawinFunc.fetch(myCfg.appSettings.webApiServerBaseUrl + 'api/Proxy/Feedback',
            {
                method: 'POST',
                body: JSON.stringify(pCustomerFeedback),
                headers: { 'Content-Type': 'application/json' }
            })
            .then(response => response.json() as Promise<APIContainer>)
            .then(container => {

                if (container.success) {
                    const data: CustomerFeedbackMdl.CustomerFeedbackModel = container.data;
                    //Do something with response             
                    dispatch({ type: 'CUSTOMERFEEDBACK_SUCCESS' });
                } else {
                    dispatch({
                        type: 'CUSTOMERFEEDBACK_ERROR', error: container.errorInfo.message
                    });
                    sawinFunc.log({ message: container.errorInfo.message, logType: LogTypes.Error, clientMessage: '' });
                }
            })
            .catch(function (err: Error) {
                dispatch({
                    type: 'CUSTOMERFEEDBACK_ERROR', error: err.message
                });
                sawinFunc.log({ message: err.message, logType: LogTypes.Error, clientMessage: '' });
            });
    },
    resetState: (): AppThunkAction<KnownAction> => (dispatch, getState) => {
        dispatch({ type: "CUSTOMERFEEDBACK_RESET" });
    }
};

export const reducer: Reducer<CustomerFeedbackMdl.CustomerFeedbackModel> = (state: CustomerFeedbackMdl.CustomerFeedbackModel | undefined, incomingAction: Action): CustomerFeedbackMdl.CustomerFeedbackModel => {

    if (state === undefined) {
        return { ...CustomerFeedbackMdl.initialState };
    }
    const action = incomingAction as KnownAction;
    switch (action.type) {
        case 'CUSTOMERFEEDBACK_PROCESSING':
            return { ...state, processing: (action as CustomerFeedbackProcessing).processing }
        case 'CUSTOMERFEEDBACK_ERROR':
            return { ...state, processing: false, error: (action as CustomerFeedbackError).error }
        case 'CUSTOMERFEEDBACK_SUCCESS':
            return { ...state, processing: false, error: '', success: 'Y' }
        case 'CUSTOMERFEEDBACK_RESET':
            return { ...state, ...CustomerFeedbackMdl.initialState }
        default:
            return state;
    }
}; 